module.exports = __webpack_public_path__ + "img/cerveza.efc38bcb.png";